var constants = require('../constants');
var initialState = require('../initialState');
var api = require('../../../utils/api');
var commonActions = require('../../common/actions/common');
var dashboardUtils = require('../utils');

var totalScoresActions = (function() {
    var _requestTotalScores = function() {
        return {
            type: constants.REQUEST_TOTAL_SCORES
        };
    }

    var _receiveTotalScores = function(data) {
        var id2Symptom = dashboardUtils.getId2Item(initialState.symptomList);

        data.scores.forEach(function(score){
            score.data.forEach(function(scoreItem){
                scoreItem.item = id2Symptom[scoreItem.symptom.id];
            });
        });

        return {
            type: constants.RECEIVE_TOTAL_SCORES,
            data: dashboardUtils.getScoresRelatedData(data.scores)
        };
    }

    var _fetchTotalScoresError = function(error) {
        return {
            type: constants.REQUEST_TOTAL_SCORES_ERROR,
            errors: error.data
        };
    }

    var _fetchTotalScores = function(accessToken) {
        return function(dispatch) {
            dispatch(_requestTotalScores());
            api.get('/proxy/v1/scores', accessToken)
                .then(function(res) {
                    dispatch(_receiveTotalScores(res));
                })
                .catch(function(error) {
                    if(error.response){
                        if(error.response.data.message === 'No scores found for user.'){
                            dispatch(_receiveTotalScores({scores: []}));
                        }else{
                            dispatch(_fetchTotalScoresError(error.response));
                        }
                    }else{
                        dispatch(commonActions.setGenericError('', error.message));
                    }
                });
        };
    }

    var _shouldFetchTotalScores = function(state) {
        var scores = state.dashboard.totalScores.scores;
        if (scores && scores.length > 0) {
            return false;
        } else {
            return true;
        }
    }

    var _fetchTotalScoresIfNeeded = function(accessToken) {
        return function(dispatch, getState) {
            if (_shouldFetchTotalScores(getState())) {
                return dispatch(_fetchTotalScores(accessToken))
            }
        }
    }

    return {
        fetchTotalScoresIfNeeded: _fetchTotalScoresIfNeeded
    }
})();

module.exports = totalScoresActions;


// WEBPACK FOOTER //
// ./src/common/modules/dashboard/actions/get-total-scores.js